import { serviceHelper } from '../utils/serviceHelper'

const getAxiosCreate = () => {
  return serviceHelper.createApiClient()
}

export default async key => {
  if (Array.isArray(key)) {
    const [url, params] = key
    const { data } = await getAxiosCreate().get(url, {
      params
    })
    return data
  }
  const { data } = await getAxiosCreate().get(key)
  return data
}
